package net.zagart.ai.core.client.deepseek.exception

class DeepseekException(
    message: String,
    cause: Throwable? = null
) : Exception(message, cause)
